import { render } from "./PermissionSetting.vue?vue&type=template&id=4c7d1c44&scoped=true"
import script from "@/assets/js/permission.js?vue&type=script&lang=js&external"
export * from "@/assets/js/permission.js?vue&type=script&lang=js&external"

import "@/assets/css/account.css?vue&type=style&index=0&id=4c7d1c44&scoped=true&lang=css&external"
import "@/assets/css/permission.css?vue&type=style&index=1&id=4c7d1c44&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7d1c44"]])

export default __exports__